import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import { HomeConfigProvider } from './context/HomeConfigContext.jsx';
import { GalleryConfigProvider } from './context/GalleryConfigContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import HomePage from './pages/HomePage.jsx';
import GaleriaPage from './pages/GaleriaPage.jsx';
import RegistroPage from './pages/RegistroPage.jsx';
import ModalidadSatelitePage from './pages/ModalidadSatelitePage.jsx';
import FloatingButtons from './components/FloatingButtons.jsx';
import AdminProtectedRoute from './components/AdminProtectedRoute.jsx';
import AdminLayout from './pages/admin/AdminLayout.jsx';
import AdminLoginPage from './pages/admin/AdminLoginPage.jsx';
import HomeAdminPage from './pages/admin/HomeAdminPage.jsx';
import RegistrosPage from './pages/admin/RegistrosPage.jsx';
import SatelitePage from './pages/admin/SatelitePage.jsx';
import GaleriaAdminPage from './pages/admin/GaleriaAdminPage.jsx';
import GoogleAnalytics from './components/GoogleAnalytics.jsx';

function App() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <AuthProvider>
      <GoogleAnalytics />
      <GalleryConfigProvider>
        <HomeConfigProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/galeria" element={<GaleriaPage />} />
            <Route path="/registro" element={<RegistroPage />} />
            <Route path="/modalidad-satelite" element={<ModalidadSatelitePage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin"
              element={
                <AdminProtectedRoute>
                  <AdminLayout />
                </AdminProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/home" replace />} />
              <Route path="home" element={<HomeAdminPage />} />
              <Route path="registros" element={<RegistrosPage />} />
              <Route path="satelite" element={<SatelitePage />} />
              <Route path="galeria" element={<GaleriaAdminPage />} />
            </Route>
          </Routes>
          {!isAdmin && <FloatingButtons />}
        </HomeConfigProvider>
      </GalleryConfigProvider>
    </AuthProvider>
  );
}


export default App;
